import { getTimestamp } from '@utils/common.util';
import i18n from '@assets/i18n/index';
import dayjs from 'dayjs';
export default {
    // startToDisplay条件中 页面到达率下拉列表
    scrollMatchOptions: [
        { value: '0%', text: 'experience.setting.first_view' },
        { value: '10%', text: '10%' },
        { value: '20%', text: '20%' },
        { value: '30%', text: '30%' },
        { value: '40%', text: '40%' },
        { value: '50%', text: '50%' },
        { value: '60%', text: '60%' },
        { value: '70%', text: '70%' },
        { value: '80%', text: '80%' },
        { value: '90%', text: '90%' },
        { value: '100%', text: 'experience.setting.end_view' }
    ],
    // displayAt条件中 匹配模式下拉列表
    entryPatternList: [
        { value: '[()]', text: 'common.include' },
        { value: '![()]', text: 'common.exclude', hide: true },
        { value: '[(', text: 'common.head_match' },
        { value: ')]', text: 'common.end_match' },
        { value: '==', text: 'common.exact_match' },
        { value: 'Rex', text: 'common.regex', hide: true }
        // {'value':"!*",'text':i18n.t('common.empty')}
    ],
    config: {
        start: [
            {
                type: 'UserBlur',
                value: true,
                condition: '=='
            }, // 用户失去焦点
            {
                type: 'UserStay',
                value: '', //用户停留时间 单位s
                condition: '>='
            },
            {
                type: 'UserStop',
                value: '', //用户停止活动时间 单位s
                condition: '>='
            },
            {
                type: 'ScrollMatch',
                value: '0%',
                condition: '>='
            }
        ],
        stop: [
            {
                type: 'SeenTimes',
                value: 1,
                condition: '>'
            },
            {
                type: 'ClickButton',
                value: true,
                condition: '=='
            },
            {
                type: 'CloseTimes',
                value: 1,
                condition: '>'
            },
            {
                type: 'FormSubmitted',
                value: 0,
                condition: '>='
            }
        ],
        schedule: [
            {
                type: 'Dater',
                value: [1555430400, 1558195199], // 存放form和to 时间戳 to可为空
                condition: ''
            },
            {
                type: 'Week',
                value: [0, 1, 2, 3, 4, 5, 6], // 0代表sunday 1代表monday 依次类推
                condition: ''
            },
            {
                type: 'Time',
                value: ['09:00', '18:00'],
                condition: ''
            }
        ],
        when: [
            {
                type: 'URL', // 两种值 URL(默认) URLGROUP
                condition: '[()]', //条件值 等于 不等于 包含 头匹配 尾匹配
                value: ''
            }
        ],
        timezone: {
            profile: '+8:00',
            useVisitor: true // 是否使用访客时区
        }
    }
};

export const scrollMatchOptions = [
    { value: '0%', text: i18n.global.t('experience.setting.first_view') },
    { value: '10%', text: '10%' },
    { value: '20%', text: '20%' },
    { value: '30%', text: '30%' },
    { value: '40%', text: '40%' },
    { value: '50%', text: '50%' },
    { value: '60%', text: '60%' },
    { value: '70%', text: '70%' },
    { value: '80%', text: '80%' },
    { value: '90%', text: '90%' },
    { value: '100%', text: i18n.global.t('experience.setting.end_view') }
];

export const entryPatternList = [
    { value: '[()]', text: 'experience.common.include' },
    { value: '![()]', text: 'experience.common.exclude', hide: true },
    { value: '[(', text: 'experience.common.head_match' },
    { value: ')]', text: 'experience.common.end_match' },
    { value: '==', text: 'experience.common.exact_match' },
    { value: 'Rex', text: 'experience.common.regex', hide: true }
    // {'value':"!*",'text':i18n.t('common.empty')}
];

export const originalPatternList = ['[()]', '![()]', '[(', 'Rex']; // 没有合参概念的条件

export const pageTypeList = [
    {
        value: 'URL',
        goalValue: 'page', // 创建goal里用的value值是page
        text: 'experience.setting.includes_params',
        tip: 'experience.setting.includes_params_tip'
    },
    {
        value: 'CombinedPage',
        goalValue: 'combinedPage', // 创建goal里用的value值是combinedPage
        text: 'experience.setting.exclude_params',
        tip: 'experience.setting.exclude_params_tip'
    }
];

export const schedueDefaultMeta = {
    start: '1',
    stop: '1',
    delivery: '1',
    startDate: new Date(getTimestamp('start')),
    stopDate: new Date(getTimestamp('stop')),
    startDateStr: dayjs(new Date(getTimestamp('start'))).format('YYYY-MM-DD HH:mm:ss'),
    stopDateStr: dayjs(new Date(getTimestamp('stop'))).format('YYYY-MM-DD HH:mm:ss'),
    time: ['00:00', '23:59'],
    week: [
        { status: true, code: 'sun' },
        { status: true, code: 'mon' },
        { status: true, code: 'tue' },
        { status: true, code: 'wed' },
        { status: true, code: 'thu' },
        { status: true, code: 'fri' },
        { status: true, code: 'sat' }
    ]
};

export const positionOptions = [
    {
        code: 'pos-left-top',
        icon: 'pos-left-top',
        cssAnimation: 'animationFadeInLeft',
        cssAnimationName: 'engage--fadeInLeft',
        row: 'top',
        col: 'left',
        defaultStyle: {
            left: '12px',
            top: '12px',
            bottom: 'initial',
            right: 'initial',
            position: 'fixed',
            transform: 'translate(0, 0)'
        }
    },
    {
        code: 'pos-center-top',
        icon: 'pos-center',
        cssAnimation: 'animationFadeIn',
        cssAnimationName: 'engage--fadeIn',
        row: 'top',
        col: 'center',
        defaultStyle: {
            left: '50%',
            top: '12px',
            bottom: 'initial',
            right: 'initial',
            transform: 'translate(-50%, 0)',
            position: 'fixed'
        }
    },
    {
        code: 'pos-right-top',
        icon: 'pos-right-bottom',
        cssAnimation: 'animationFadeInRight',
        cssAnimationName: 'engage--fadeInRight',
        row: 'top',
        col: 'right',
        defaultStyle: {
            left: 'initial',
            top: '12px',
            bottom: 'initial',
            right: '12px',
            transform: 'translate(0, 0)',
            position: 'fixed'
        }
    },
    {
        code: 'pos-left-center',
        icon: 'pos-left-center',
        cssAnimation: 'animationFadeInLeft',
        cssAnimationName: 'engage--fadeInLeft',
        row: 'center',
        col: 'left',
        defaultStyle: {
            left: '12px',
            top: '50%',
            bottom: 'initial',
            right: 'initial',
            position: 'fixed',
            transform: 'translate(0, -50%)'
        }
    },
    {
        code: 'pos-center',
        icon: 'pos-center',
        cssAnimation: 'animationFadeIn',
        row: 'center',
        col: 'center',
        cssAnimationName: 'engage--fadeIn',
        default: true,
        defaultStyle: {
            left: '50%',
            top: '50%',
            bottom: 'initial',
            right: 'initial',
            transform: 'translate(-50%, -50%)',
            position: 'fixed'
        }
    },
    {
        code: 'pos-right-center',
        icon: 'pos-right-center',
        cssAnimation: 'animationFadeInRight',
        cssAnimationName: 'engage--fadeInRight',
        row: 'center',
        col: 'right',
        defaultStyle: {
            left: 'initial',
            top: '50%',
            bottom: 'initial',
            right: '12px',
            transform: 'translate(0, -50%)',
            position: 'fixed'
        }
    },
    {
        code: 'pos-left-bottom',
        icon: 'pos-left-bottom',
        cssAnimation: 'animationFadeInLeft',
        cssAnimationName: 'engage--fadeInLeft',
        row: 'bottom',
        col: 'left',
        defaultStyle: {
            left: '12px',
            top: 'initial',
            bottom: '12px',
            right: 'initial',
            position: 'fixed',
            transform: 'translate(0, 0)'
        }
    },
    {
        code: 'pos-center-bottom',
        icon: 'pos-center',
        row: 'bottom',
        col: 'center',
        cssAnimation: 'animationFadeIn',
        cssAnimationName: 'engage--fadeIn',
        defaultStyle: {
            left: '50%',
            top: 'initial',
            bottom: '12px',
            right: 'initial',
            transform: 'translate(-50%, 0)',
            position: 'fixed',
            margin: 'auto'
        }
    },
    {
        code: 'pos-right-bottom',
        icon: 'pos-right-bottom',
        cssAnimation: 'animationFadeInRight',
        cssAnimationName: 'engage--fadeInRight',
        row: 'bottom',
        col: 'right',
        defaultStyle: {
            left: 'initial',
            top: 'initial',
            bottom: '12px',
            right: '12px',
            transform: 'translate(0, 0)',
            position: 'fixed',
            margin: 'auto'
        }
    }
];

export const stickyPosOptions = [
    {
        code: 'pos-sticky-top',
        row: 'top',
        col: 'center',
        defaultStyle: {
            left: '50%',
            top: '0',
            bottom: 'initial',
            right: 'initial',
            transform: 'translate(-50%, 0)',
            position: 'fixed'
        }
    },
    {
        code: 'pos-sticky-bottom',
        row: 'bottom',
        col: 'center',
        cssAnimation: 'animationFadeIn',
        cssAnimationName: 'engage--fadeIn',
        defaultStyle: {
            left: '50%',
            top: 'initial',
            bottom: '0',
            right: 'initial',
            transform: 'translate(-50%, 0)',
            position: 'fixed',
            margin: 'auto'
        }
    }
];

export const calculateDaysOptions = [
    {
        id: 3,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 4,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 5,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 6,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 7,
        name: 'experience.setting.calculateDays',
        default: true
    },
    {
        id: 8,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 9,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 10,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 11,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 12,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 13,
        name: 'experience.setting.calculateDays'
    },
    {
        id: 14,
        name: 'experience.setting.calculateDays'
    }
];

export const calculateConfidenceOptions = [
    {
        id: 90,
        name: 'experience.setting.calculateConfidence'
    },
    {
        id: 95,
        name: 'experience.setting.calculateConfidence',
        default: true
    },
    {
        id: 98,
        name: 'experience.setting.calculateConfidence'
    }
];
